import { render, staticRenderFns } from "./EventCreateBasics.vue?vue&type=template&id=2bf05f30&"
import script from "./EventCreateBasics.vue?vue&type=script&lang=js&"
export * from "./EventCreateBasics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bf05f30')) {
      api.createRecord('2bf05f30', component.options)
    } else {
      api.reload('2bf05f30', component.options)
    }
    module.hot.accept("./EventCreateBasics.vue?vue&type=template&id=2bf05f30&", function () {
      api.rerender('2bf05f30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/steps/EventCreateBasics.vue"
export default component.exports